import { IconSvg, IconSvgProps } from "./icon"

export default function TwoPeople(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M9.428 9.896a2.893 2.893 0 1 0 0-5.786 2.893 2.893 0 0 0 0 5.786h0Zm5.786 9.643H3.643v-1.286a5.786 5.786 0 0 1 11.571 0v1.286h0ZM14.571 4.11a2.893 2.893 0 1 1 0 5.786m2.057 2.816a5.786 5.786 0 0 1 3.729 5.4v1.427h-1.929" />
    </IconSvg>
  )
}
